const CARDS: { title: string; desc: string; tags: string[] }[] = [
  {
    title: 'Doc Infuser',
    desc: 'DOC, PDF 등 다양한 포맷의 문서에서 손쉽게 내용을 추출·저장하는 오픈소스 기반 문서 추출 시스템.',
    tags: ['추출 규칙 관리', '다양한 문서 포맷', '무설치 실행'],
  },
  {
    title: 'Data Map',
    desc: 'AI 기반 유사도 분석 결과를 시각화로 제공하고, 연계된 모든 메타데이터를 손쉽게 확인합니다.',
    tags: ['유사도 분석', '메타데이터 시각화', '연계 탐색'],
  },
];

/** 데이터 활용을 완성하는 제품들 — Doc Infuser + Data Map 2-up 카드. */
export default function ProductDuo() {
  return (
    <section className="pd-section pd-duo">
      <div className="pd-container">
        <div className="pd-head">
          <span className="pd-eyebrow pd-eyebrow--plain">MORE SOLUTIONS</span>
          <h2 className="pd-h2">데이터 활용을 완성하는 제품들</h2>
        </div>

        <div className="pd-duo__grid">
          {CARDS.map((card) => (
            <div className="pd-duo__card" key={card.title}>
              <h3 className="pd-duo__title">{card.title}</h3>
              <p className="pd-duo__desc">{card.desc}</p>
              <div className="pd-duo__tags">
                {card.tags.map((t) => (
                  <span className="pd-chip" key={t}>
                    {t}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
